
import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class LoadingMask extends Vue {
  @Prop({ required: true })
  active: boolean

  @Prop({ required: false })
  text: string

  @Prop({ required: false, default: true })
  spinner: boolean
}
